const BASE = process.env.REACT_APP_API_URL || 'https://web-production-120c.up.railway.app';

async function api(path, options = {}) {
  const TOKEN = localStorage.getItem('shaheen_admin_token') || '';
  const KEY   = localStorage.getItem('shaheen_admin_key')   || '';
  // Bearer token is the primary auth method for browser sessions.
  // X-Shaheen-Key is kept for curl/server-to-server (will be empty string in browser).
  const authHeader = TOKEN ? `Bearer ${TOKEN}` : '';
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': authHeader,
      'X-Shaheen-Key': KEY,
      ...options.headers,
    },
    ...options,
  });
  let data;
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) {
    data = await res.json();
  } else {
    const text = await res.text();
    throw new Error(`Server returned ${res.status} (not JSON). The endpoint may not be deployed yet.`);
  }
  if (!res.ok) throw new Error(data.error || `Error ${res.status}`);
  return data;
}

export const getClients      = ()           => api('/admin/clients');
export const getClient       = (id)         => api(`/client/${id}`);
export const getClientHealth   = (id)       => api(`/client/${id}/health`);
export const getClientScans    = (id)       => api(`/client/${id}/scans`);
export const getClientSecurity = (id)       => api(`/admin/clients/${id}/security`);
export const createClient  = (body)       => api('/register', { method: 'POST', body: JSON.stringify(body) });
export const updateClient  = (id, body)   => api(`/admin/clients/${id}`, { method: 'PUT', body: JSON.stringify(body) });
export const deleteClient  = (id)         => api(`/admin/clients/${id}`, { method: 'DELETE' });
export const renameClient  = (id, new_id) => api(`/admin/clients/${id}/rename`, { method: 'POST', body: JSON.stringify({ new_id }) });
export const setup2fa      = (id, name)   => api('/login/setup-2fa', { method: 'POST', body: JSON.stringify({ client_id: id, client_name: name }) });
export const reset2fa      = (id, name)   => api('/login/setup-2fa', { method: 'POST', body: JSON.stringify({ client_id: id, client_name: name }) });
export const getCases      = ()           => api('/admin/cases');
export const getStats      = ()           => api('/status');
export const adminLogin    = (username)   => api('/admin/login', { method: 'POST', body: JSON.stringify({ username }) });
export const getScheduler  = ()           => api('/admin/scheduler');
export const runJob        = (job)        => api(`/admin/scheduler/run/${job}`, { method: 'POST' });
export const getClientEmails = (id)       => api(`/admin/clients/${id}/emails`);
export const getThreatActors      = (industry, region) => api(`/admin/threat-actors${industry || region ? `?industry=${industry||''}&region=${region||''}` : ''}`);
export const getClientWatchlist   = (id)               => api(`/client/${id}/threat-watchlist`);
export const assignThreatActor    = (actorId, clientId, reason) => api(`/admin/threat-actors/${actorId}/assign/${clientId}`, { method: 'POST', body: JSON.stringify({ reason }) });
export const unassignThreatActor  = (actorId, clientId)         => api(`/admin/threat-actors/${actorId}/unassign/${clientId}`, { method: 'DELETE' });
export const syncThreatActors        = ()                            => api('/admin/threat-actors/sync', { method: 'POST' });
export const getTravelAdvisories     = (id)                          => api(`/client/${id}/travel-advisories`);
export const getTravelAdvisory       = (id, advisoryId)              => api(`/client/${id}/travel-advisories/${advisoryId}`);
export const generateTravelAdvisory  = (id, country, travel_date)    => api(`/client/${id}/travel-advisory`, { method: 'POST', body: JSON.stringify({ country, travel_date }) });
